import { useNavigate, useParams } from 'react-router-dom';
import { useLoggedUser } from '../user/useLoggedUser';

export const useEntityNavigation = () => {
  const navigation = useNavigate();
  const { marketId, cooperativeId } = useParams();
  const { userType } = useLoggedUser();

  const navigateTo = (path: string = '/') => {
    navigation(
      `/${userType.toLowerCase()}/${userType === 'MARKET' ? marketId : cooperativeId}${path}`,
    );
  };
  return { navigateTo };
};
